import { EnvType, RequestType } from "src/interfaces";

export const environment: EnvType = {
  production: process.env.REACT_APP_PROD === "true" ? true : false,
  siteTitle: process.env.REACT_APP_TITLE || "",
  apiPath: process.env.REACT_APP_API || "",
  apiKey: process.env.REACT_APP_KEY || "",
};
